import React, { useEffect, useRef } from "react";
import { Menu } from "primereact/menu";
import { useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import { useGlobalContext } from "./Config";

const AppTopbar = (props) => {

  const navigate = useNavigate();
  const menuMantenedores = useRef(null);

  const itemsMantenedores = [
    { label: "Competencias", command: () => navigate("/competencias") },
    { label: "Causas de Pérdida", command: () => navigate("/causas-perdida") },
    {
      label: "Cierres de Cotización",
      command: () => navigate("/cierres-cotizacion"),
    },
    { label: "Estados", command: () => navigate("/estados") },
    { label: "Usuarios", command: () => navigate("/usuarios") },
    { label: "Constantes P.E.", command: () => navigate("/constantes-pe") },
    { label: "Materia Prima P.E.", command: () => navigate("/materia-prima-pe") },
    {
      label: "Servicio de Armado P.E.",
      command: () => navigate("/servicio-armado-pe"),
    },
    {
      label: "Servicio de Corte P.E.",
      command: () => navigate("/servicio-corte-pe"),
    },
    {
      label: "Servicio de Perforacion P.E.",
      command: () => navigate("/servicio-perforacion-pe"),
    },
  ];

  const { styleProperties } = useGlobalContext();

  // Fixed for 6.1.0
  // eslint-disable-next-line
  const searchPanel = useRef(null);

  useEffect(() => {
    // Fixed for 6.1.0
    /*if (props.searchActive) {
            searchPanel.current.element.focus();
        }*/
  }, [props.searchActive]);


  return (
    <div className="layout-topbar shadow-4">
      <div className="layout-topbar-left">
        <button
          type="button"
          style={{ cursor: "pointer" }}
          className="layout-topbar-logo p-link"
          onClick={() => navigate("/tablero")}
        >
          {" "}
          <img src={styleProperties.logo} alt="" height="100%" width="80%" />
        </button>
        <button
          type="button"
          className="layout-menu-button shadow-6 p-link lg:hidden"
          onClick={props.onMenuButtonClick}
        >
          <i className="pi pi-chevron-right"></i>
        </button>
        {/* <button type="button" className="layout-topbar-mobile-button p-link">
          <i
            className="pi pi-ellipsis-v fs-large"
            onClick={props.onMobileTopbarButtonClick}
          ></i>
        </button> */}
      </div>
      <div className="layout-topbar-right">
        <div className="flex align-items-center justify-content-between w-full">
          <div className="flex align-items-center gap-2">
            <Button
              type="button"
              className="p-button-text text-white font-medium"
              onClick={() => navigate("/boleta")}
              label="Cotización Boleta"
              icon="pi pi-file"
            />

            <Button
              type="button"
              className="p-button-text text-white font-medium"
              onClick={() => navigate("/factura")}
              label="Cotización Factura"
              icon="pi pi-file-o"
            />

            <Button
              type="button"
              className="p-button-text text-white font-medium"
              onClick={() => navigate("/cotizaciones")}
              label="Cotizaciones"
              icon="pi pi-list"
            />

            <Button
              type="button"
              className="p-button-text text-white font-medium"
              onClick={() => navigate("/reportes")}
              label="Reportes"
              icon="pi pi-chart-bar"
            />

            <Menu
              model={itemsMantenedores}
              popup
              ref={menuMantenedores}
              id="popup_menu_mantenedores"
            />
            <Button
              type="button"
              className="p-button-text text-white font-medium block h-2rem border-right-1 surface-border mx-2"
              onClick={(event) => menuMantenedores.current.toggle(event)}
              aria-controls="popup_menu_mantenedores"
              aria-haspopup
              label="Mantenedores"
              icon="pi pi-cog"
            />
          </div>

          <div className="flex align-items-center gap-1 mr-3">
            <Button
              type="button"
              className="p-button-text text-white"
              onClick={() => props.onColorModeChange(props.colorMode === "dark" ? "light" : "dark")}
              icon={props.colorMode === "dark" ? "pi pi-sun" : "pi pi-moon"}
              label={props.colorMode === "dark" ? "Modo claro" : "Modo oscuro"}
            />
            <Button
              type="button"
              className="p-button-text text-white"
              onClick={() => {
                sessionStorage.clear();
                navigate("/");
              }}
              label="Salir"
              icon="pi pi-power-off"
            />

            {/* MAJOR.MINOR.PATCH */}
            <span className="">Ver. 1.0.3</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppTopbar;
